import type { VWOCookieConfig } from './types';

/**
 * Default cookie configuration for the VWO visitor ID.
 * Non-httpOnly so GTM can read it for client-side conversion tracking.
 */
export const VWO_COOKIE_CONFIG: VWOCookieConfig = {
	name: 'vwo_fme_id',
	maxAge: 90 * 24 * 60 * 60, // 90 days in seconds
	path: '/',
	httpOnly: false,
	sameSite: 'lax',
};

/**
 * Generates a VWO web-format UUID: "D" + 32 uppercase hex chars.
 *
 * This format passes the FME SDK's `isWebUuid` check so the SDK uses
 * it verbatim as the `visId`. GTM can read the same cookie value
 * and send it in event payloads for conversion tracking.
 *
 * @example
 * generateVWOVisitorId() // "D1A2B3C4D5E6F7A8B9C0D1E2F3A4B5C6"
 */
export function generateVWOVisitorId(): string {
	const hex = crypto.randomUUID().replaceAll('-', '').toUpperCase();
	return `D${hex}`;
}
